import styled from '@emotion/styled';

import { SectionSubTitle } from '../../styledComponents/Typography/Typography';

export const StyledReportsSubtitle = styled(SectionSubTitle)`
  font-size: 1rem;
  margin: 2.5rem 0 2.5rem;
`;
